var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 314,
    viewBox: "0 0 316 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05888 8.05888 0 18 0H173C182.941 0 191 8.05888 191 18V44.8039C191 55.8496 182.046 64.8039 171 64.8039H159.605C142.15 64.8039 128 78.9539 128 96.4089C128 106.676 119.676 115 109.409 115H18C8.05888 115 0 106.941 0 97V18Z",
    fill: "#151521"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 97,
    r: 25,
    fill: "#151521"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.111 109.635H164.022M145.889 109.635H157.977M161 106.606V102.063",
    stroke: "#FFB7D7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.999 112.664C162.668 112.664 164.021 111.308 164.021 109.635C164.021 107.962 162.668 106.606 160.999 106.606C159.33 106.606 157.976 107.962 157.976 109.635C157.976 111.308 159.33 112.664 160.999 112.664Z",
    stroke: "#FFB7D7",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.422 92.977C149.22 92.977 148.066 93.4556 147.216 94.3076C146.366 95.1596 145.889 96.3152 145.889 97.5201C145.889 98.725 146.366 99.8805 147.216 100.733C148.066 101.585 149.22 102.063 150.422 102.063H171.577C172.173 102.063 172.762 101.946 173.312 101.717C173.862 101.489 174.362 101.154 174.783 100.733C175.204 100.311 175.538 99.8098 175.766 99.2586C175.994 98.7074 176.111 98.1167 176.111 97.5201C176.111 96.9234 175.994 96.3327 175.766 95.7815C175.538 95.2303 175.204 94.7295 174.783 94.3076C174.362 93.8857 173.862 93.5511 173.312 93.3228C172.762 93.0945 172.173 92.977 171.577 92.977M150.422 92.977H171.577M150.422 92.977C149.22 92.977 148.066 92.4983 147.216 91.6463C146.366 90.7943 145.889 89.6388 145.889 88.4339C145.889 87.2289 146.366 86.0734 147.216 85.2214C148.066 84.3694 149.22 83.8907 150.422 83.8907H171.577C172.78 83.8907 173.933 84.3694 174.783 85.2214C175.633 86.0734 176.111 87.2289 176.111 88.4339C176.111 89.6388 175.633 90.7943 174.783 91.6463C173.933 92.4983 172.78 92.977 171.577 92.977",
    stroke: "#FFB7D7",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.512 88.434H171.578M162.512 97.5202H171.578",
    stroke: "#FFB7D7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.694 88.4339C152.694 88.8576 152.352 89.1983 151.933 89.1983C151.514 89.1983 151.172 88.8576 151.172 88.4339C151.172 88.0103 151.514 87.6696 151.933 87.6696C152.352 87.6696 152.694 88.0103 152.694 88.4339Z",
    fill: "white",
    stroke: "#FFB7D7",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.694 97.5201C152.694 97.9438 152.352 98.2845 151.933 98.2845C151.514 98.2845 151.172 97.9438 151.172 97.5201C151.172 97.0964 151.514 96.7557 151.933 96.7557C152.352 96.7557 152.694 97.0964 152.694 97.5201Z",
    fill: "white",
    stroke: "#FFB7D7",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 97.5862C195.5 88.4259 202.926 81 212.086 81H296C306.493 81 315 89.5066 315 100V294C315 304.493 306.493 313 296 313H20C9.50659 313 1 304.493 1 294V151C1 140.507 9.50659 132 20 132H161.086C180.092 132 195.5 116.592 195.5 97.5862Z",
    stroke: "#FFB7D7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinServer);
export default __webpack_public_path__ + "static/media/min-server.ae18eac7783c2f0a6fdb4eae06d03574.svg";
export { ForwardRef as ReactComponent };